import type { Dispatch } from "react";
import type { NotificationPushPayload } from "@tc-superpods/app-contract";
import { successNotificationDurationMs } from "./config";
import type { ShellAction } from "./state";

export interface NotificationController {
  push: (payload: NotificationPushPayload) => void;
  dismiss: (id: string) => void;
}

export function createNotificationController(
  dispatch: Dispatch<ShellAction>
): NotificationController {
  const timers = new Map<string, number>();
  const live = new Set<string>();
  let sequence = 0;

  function push(payload: NotificationPushPayload): void {
    const id = `notification-${(sequence += 1)}`;
    live.add(id);
    dispatch({
      type: "notification-add",
      notification: { ...payload, id }
    });

    if (payload.level === "success") {
      const timeoutId = window.setTimeout(() => {
        dismiss(id);
      }, successNotificationDurationMs);
      timers.set(id, timeoutId);
    }
  }

  function dismiss(id: string): void {
    if (!live.has(id)) {
      return;
    }

    live.delete(id);
    clearTimer(id);
    dispatch({ type: "notification-remove", id });
  }

  function clearTimer(id: string): void {
    const timeoutId = timers.get(id);

    if (timeoutId === undefined) {
      return;
    }

    window.clearTimeout(timeoutId);
    timers.delete(id);
  }

  return {
    push,
    dismiss
  };
}
